import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../../assets/images/file-json.png'


const _hoisted_1 = { class: "overlaytool" }
const _hoisted_2 = { class: "overlaytool_wrapper" }
const _hoisted_3 = { class: "overlaytool_left" }
const _hoisted_4 = { class: "overlaytool_title" }
const _hoisted_5 = { class: "block-one" }
const _hoisted_6 = { class: "overlaytool_secondarytitle" }
const _hoisted_7 = { class: "overlaytool_desc" }
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = { class: "block-two" }
const _hoisted_10 = { class: "overlaytool_secondarytitle" }
const _hoisted_11 = { class: "overlaytool_desc" }
const _hoisted_12 = { class: "form-group" }
const _hoisted_13 = { class: "overlaytool_desc" }
const _hoisted_14 = {
  key: 0,
  class: "form-group"
}
const _hoisted_15 = ["disabled"]
const _hoisted_16 = {
  key: 1,
  class: "form-group"
}
const _hoisted_17 = ["value"]
const _hoisted_18 = { class: "overlaytool_coordinates" }
const _hoisted_19 = { class: "ne-corner" }
const _hoisted_20 = { class: "overlaytool_coordinates_title" }
const _hoisted_21 = { class: "form-group" }
const _hoisted_22 = ["disabled"]
const _hoisted_23 = { class: "form-group" }
const _hoisted_24 = ["disabled"]
const _hoisted_25 = { class: "centerpoint" }
const _hoisted_26 = { class: "overlaytool_coordinates_title" }
const _hoisted_27 = { class: "form-group" }
const _hoisted_28 = ["disabled"]
const _hoisted_29 = { class: "form-group" }
const _hoisted_30 = ["disabled"]
const _hoisted_31 = { class: "sw-corner" }
const _hoisted_32 = { class: "overlaytool_coordinates_title" }
const _hoisted_33 = { class: "form-group" }
const _hoisted_34 = ["disabled"]
const _hoisted_35 = { class: "form-group" }
const _hoisted_36 = ["disabled"]
const _hoisted_37 = { class: "form-group" }
const _hoisted_38 = { class: "overlaytool_desc" }
const _hoisted_39 = { class: "form-group" }
const _hoisted_40 = {
  class: "form-group",
  style: {"display":"flex"}
}
const _hoisted_41 = ["disabled"]
const _hoisted_42 = { class: "form-group" }
const _hoisted_43 = { class: "overlaytool_right" }
const _hoisted_44 = {
  key: 0,
  class: "loading-overlay"
}
const _hoisted_45 = {
  key: 1,
  class: "embtoolbox"
}
const _hoisted_46 = {
  class: "overlaytool geoposition",
  style: {"display":"none"}
}
const _hoisted_47 = { class: "overlaytool_wrapper" }
const _hoisted_48 = { class: "overlaytool_left" }
const _hoisted_49 = { class: "block-one" }
const _hoisted_50 = { class: "overlaytool_title" }
const _hoisted_51 = { class: "overlaytool_secondarytitle" }
const _hoisted_52 = { class: "block-two" }
const _hoisted_53 = { class: "overlaytool_secondarytitle" }
const _hoisted_54 = { class: "overlaytool_desc" }
const _hoisted_55 = { class: "overlaytool_coordinates" }
const _hoisted_56 = { class: "ne-corner" }
const _hoisted_57 = { class: "overlaytool_coordinates_title" }
const _hoisted_58 = { class: "centerpoint" }
const _hoisted_59 = { class: "overlaytool_coordinates_title" }
const _hoisted_60 = { class: "sw-corner" }
const _hoisted_61 = { class: "overlaytool_coordinates_title" }

import { ref } from "vue"
  import MapPreview from "../MapPreview.vue";
  import { apiMessages } from "../../api/message-api";
  import { Settings } from "@/constant/enums";
  import { apiFetchNeighbourhoodsForPreview } from "../../api/preview-api";
  import { Community, Neighbourhood } from "../../types/preview";


  
export default /*@__PURE__*/_defineComponent({
  __name: 'PlatMapPreview',
  setup(__props) {

  const loading = ref(false)
  const showPreview = ref(false)

  const selectedNeighborhood = ref({} as Neighbourhood)
  const neighborhoods = ref<Neighbourhood[]>([])
  const neighbourhood = ref("0")

  const svgUrl = ref("")
  const communityCode = ref("")
  const NECornerLatitude = ref("")
  const NECornerLongitude = ref("")
  const CenterpointLatitude = ref("")
  const CenterpointLongitude = ref("")
  const SWCornerLatitude = ref("")
  const SWCornerLongitude = ref("")
  const zoom = ref<any>("")

  const errors = ref<string[]>([])
  const messages = ref<any>({})
  const validationMessages = ref<any>({})

  const fieldArr = [
    "svgUrl",
    "NECornerLatitude",
    "NECornerLongitude",
    "CenterpointLatitude",
    "CenterpointLongitude",
    "SWCornerLatitude",
    "SWCornerLongitude",
    "zoom",
  ]

  // 🔹 Template refs
  const mapPreview = ref<any>(null)

  // 🔹 Lifecycle: load messages on mount
  const loadMessages = async () => {
    const { messages: msg, validationMessage } = await apiMessages("PlatMapPreview")
    messages.value = msg
    validationMessages.value = validationMessage
  }
  loadMessages()

  // 🔹 Methods

  const updateSelectedNeighborhood = () => {
    const n = neighborhoods.value.find((n) => n.id === neighbourhood.value)
    if (n) {
      selectedNeighborhood.value = n
      CenterpointLatitude.value = n.latitude.toString()
      CenterpointLongitude.value = n.longitude.toString()
    }
  }

  const getCommunityNeighborhoods = async (e: Event) => {
    loading.value = true
    neighbourhood.value = "0"
    errors.value = []
    try {
      const response = await apiFetchNeighbourhoodsForPreview(communityCode.value)
      const result: Community = response.result

      if (!result.neighborhoods.length) {
        errors.value.push(validationMessages.value.noNeighborhoodFound)
      } else {
        neighborhoods.value = result.neighborhoods
        if (neighborhoods.value.length === 1) {
          neighbourhood.value = neighborhoods.value[0].id
        }
        NECornerLatitude.value = result.ne_corner_latitude.toString()
        NECornerLongitude.value = result.ne_corner_longitude.toString()
        CenterpointLatitude.value = result.center_latitude.toString()
        CenterpointLongitude.value = result.center_longitude.toString()
        SWCornerLatitude.value = result.sw_corner_latitude.toString()
        SWCornerLongitude.value = result.sw_corner_longitude.toString()
        zoom.value = result.zoom_level || Settings.MAP_DEFAULT_SVG_SCALE
      }
    } catch (err) {
      errors.value.push(validationMessages.value.validCommunityCode)
      neighborhoods.value = []
    }
    loading.value = false
  }

  const checkAllFieldsEmpty = () => {
    let isFieldEmpty = false
    for (const item of fieldArr) {
      if (!(getFieldValue(item))) {
        isFieldEmpty = true
      }
    }
    if (isFieldEmpty) {
      errors.value.push(validationMessages.value.emptyFields)
    }
  }

  const checkValidCoordinate = () => {
    let invalid = false
    for (const item of fieldArr) {
      if (item !== "svgUrl" && validateCoordinate(getFieldValue(item))) {
        invalid = true
      }
    }
    if (invalid) {
      errors.value.push(validationMessages.value.validCoordinates)
    }
  }

  const checkLongitude = () => {
    if (
      validateLongitude(NECornerLongitude.value) ||
      validateLongitude(CenterpointLongitude.value) ||
      validateLongitude(SWCornerLongitude.value)
    ) {
      errors.value.push(validationMessages.value.validLongitude)
    }
  }

  const updateZoomLevel = () => {
    errors.value = []
    checkAllFieldsEmpty()
    checkZoomValidation()
    if (!errors.value.length && showPreview.value) {
      svgZoom()
    }
  }

  const checkZoomValidation = () => {
    if (zoom.value && (zoom.value < 10 || zoom.value > 20)) {
      errors.value.push(validationMessages.value.validZoom)
    }
  }

  const submitPreviewData = () => {
    loading.value = true
    showPreview.value = false
    errors.value = []

    checkAllFieldsEmpty()
    checkValidCoordinate()
    checkLongitude()
    checkZoomValidation()
    console.log("errors view", errors.value)
    if (!errors.value.length) {
      const timer = setTimeout(() => {
        loading.value = false
        showPreview.value = true
        clearTimeout(timer)
      }, 1000)
    } else {
      loading.value = false
      showPreview.value = false
    }
  }

  const validateLongitude = (longitudeCoordinate: string) => {
    return longitudeCoordinate && !validateCoordinate(longitudeCoordinate)
      ? !longitudeCoordinate.startsWith("-")
      : false
  }

  const validateCoordinate = (val: string) => {
    return val ? !( !isNaN(parseFloat(val)) && isFinite(parseFloat(val)) ) : false
  }

  const changeZoomLevel = (zoomLevel: number) => {
    zoom.value = zoomLevel
  }

  // 🔹 Map Preview methods
  const svgZoom = () => {
    mapPreview.value?.svgZoom(+zoom.value)
  }
  const svgZoomIn = () => {
    mapPreview.value?.svgZoomIn()
  }
  const svgZoomOut = () => {
    mapPreview.value?.svgZoomOut()
  }

  // 🔹 Helper: get reactive value by field name
  function getFieldValue(field: string): any {
    switch (field) {
      case "svgUrl": return svgUrl.value
      case "NECornerLatitude": return NECornerLatitude.value
      case "NECornerLongitude": return NECornerLongitude.value
      case "CenterpointLatitude": return CenterpointLatitude.value
      case "CenterpointLongitude": return CenterpointLongitude.value
      case "SWCornerLatitude": return SWCornerLatitude.value
      case "SWCornerLongitude": return SWCornerLongitude.value
      case "zoom": return zoom.value
    }
  }
  
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h2", _hoisted_4, _toDisplayString(messages.value.blockOneTitle), 1),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("h4", _hoisted_6, _toDisplayString(messages.value.blockOneSecondaryTitle), 1),
              _createElementVNode("p", _hoisted_7, _toDisplayString(messages.value.blockOnePMessage), 1),
              _createElementVNode("div", _hoisted_8, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  onfocus: "this.placeholder=''",
                  onblur: "this.placeholder='SVG URL'",
                  placeholder: "SVG URL",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((svgUrl).value = $event))
                }, null, 512), [
                  [_vModelText, svgUrl.value]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("h4", _hoisted_10, _toDisplayString(messages.value.blockTwoSecondaryTitle), 1),
              _createElementVNode("p", _hoisted_11, _toDisplayString(messages.value.blockTwoPMessage), 1),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("p", _hoisted_13, _toDisplayString(messages.value.communityCode), 1),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    onfocus: "this.placeholder=''",
                    onblur: "this.placeholder='Community Code'",
                    placeholder: "Community Code",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((communityCode).value = $event))
                  }, null, 512), [
                    [_vModelText, communityCode.value]
                  ])
                ]),
                (!!communityCode.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _createElementVNode("button", {
                        class: "btn",
                        style: {"margin-left":"auto"},
                        onClick: getCommunityNeighborhoods,
                        disabled: loading.value
                      }, [...(_cache[10] || (_cache[10] = [
                        _createTextVNode(" Get Neigbourhoods ", -1),
                        _createElementVNode("span", { class: "icon icon-right-white-arrow" }, null, -1)
                      ]))], 8, _hoisted_15)
                    ]))
                  : _createCommentVNode("", true),
                (neighborhoods.value.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _cache[12] || (_cache[12] = _createElementVNode("p", { class: "overlaytool_desc" }, "Neighborhoods :", -1)),
                      _withDirectives(_createElementVNode("select", {
                        class: "form-control overlaytool_formcontrol",
                        onChange: updateSelectedNeighborhood,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((neighbourhood).value = $event))
                      }, [
                        _cache[11] || (_cache[11] = _createElementVNode("option", {
                          disabled: "",
                          value: "0"
                        }, "Choose", -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(neighborhoods.value, (neighbourhood) => {
                          return (_openBlock(), _createElementBlock("option", {
                            value: neighbourhood.id,
                            key: neighbourhood.id
                          }, _toDisplayString(neighbourhood.neighborhood_name), 9, _hoisted_17))
                        }), 128))
                      ], 544), [
                        [_vModelSelect, neighbourhood.value]
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("h5", _hoisted_20, _toDisplayString(messages.value.neCorner), 1),
                  _createElementVNode("div", _hoisted_21, [
                    _withDirectives(_createElementVNode("input", {
                      disabled: !!communityCode.value,
                      type: "text",
                      class: "form-control",
                      placeholder: "NE Corner Latitude",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((NECornerLatitude).value = $event)),
                      onfocus: "this.placeholder=''",
                      onblur: "this.placeholder='NE Corner Latitude'"
                    }, null, 8, _hoisted_22), [
                      [_vModelText, NECornerLatitude.value]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _withDirectives(_createElementVNode("input", {
                      disabled: !!communityCode.value,
                      type: "text",
                      class: "form-control",
                      placeholder: "NE Corner Longitude",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((NECornerLongitude).value = $event)),
                      onfocus: "this.placeholder=''",
                      onblur: "this.placeholder='NE Corner Longitude'"
                    }, null, 8, _hoisted_24), [
                      [_vModelText, NECornerLongitude.value]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("h5", _hoisted_26, _toDisplayString(messages.value.centerPoint), 1),
                  _createElementVNode("div", _hoisted_27, [
                    _withDirectives(_createElementVNode("input", {
                      disabled: !!communityCode.value,
                      type: "text",
                      class: "form-control",
                      placeholder: "Centerpoint Latitude",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((CenterpointLatitude).value = $event)),
                      onfocus: "this.placeholder=''",
                      onblur: "this.placeholder='Centerpoint Latitude'"
                    }, null, 8, _hoisted_28), [
                      [_vModelText, CenterpointLatitude.value]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_29, [
                    _withDirectives(_createElementVNode("input", {
                      disabled: !!communityCode.value,
                      type: "text",
                      class: "form-control",
                      placeholder: "Centerpoint Longitude",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((CenterpointLongitude).value = $event)),
                      onfocus: "this.placeholder=''",
                      onblur: "this.placeholder='Centerpoint Longitude'"
                    }, null, 8, _hoisted_30), [
                      [_vModelText, CenterpointLongitude.value]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("h5", _hoisted_32, _toDisplayString(messages.value.swCorner), 1),
                  _createElementVNode("div", _hoisted_33, [
                    _withDirectives(_createElementVNode("input", {
                      disabled: !!communityCode.value,
                      type: "text",
                      class: "form-control",
                      placeholder: "SW Corner Latitude",
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((SWCornerLatitude).value = $event)),
                      onfocus: "this.placeholder=''",
                      onblur: "this.placeholder='SW Corner Latitude'"
                    }, null, 8, _hoisted_34), [
                      [_vModelText, SWCornerLatitude.value]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_35, [
                    _withDirectives(_createElementVNode("input", {
                      disabled: !!communityCode.value,
                      type: "text",
                      class: "form-control",
                      placeholder: "SW Corner Longitude",
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((SWCornerLongitude).value = $event)),
                      onfocus: "this.placeholder=''",
                      onblur: "this.placeholder='SW Corner Longitude'"
                    }, null, 8, _hoisted_36), [
                      [_vModelText, SWCornerLongitude.value]
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("h5", _hoisted_38, _toDisplayString(messages.value.zoom), 1),
              _createElementVNode("div", _hoisted_39, [
                _withDirectives(_createElementVNode("input", {
                  onChange: updateZoomLevel,
                  type: "number",
                  class: "form-control",
                  placeholder: "Zoom",
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((zoom).value = $event)),
                  onfocus: "this.placeholder=''",
                  onblur: "this.placeholder='Zoom'"
                }, null, 544), [
                  [_vModelText, zoom.value]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("button", {
                class: "btn",
                style: {"margin-left":"auto"},
                onClick: submitPreviewData,
                disabled: loading.value
              }, [...(_cache[13] || (_cache[13] = [
                _createTextVNode(" Show preview ", -1),
                _createElementVNode("span", { class: "icon icon-right-white-arrow" }, null, -1)
              ]))], 8, _hoisted_41)
            ]),
            _createElementVNode("div", _hoisted_42, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(errors.value, (error) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "is-error",
                  key: error
                }, " · " + _toDisplayString(error), 1))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_43, [
          (loading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                _createElementVNode("div", {
                  class: _normalizeClass(!!loading.value ? 'loading' : '')
                }, null, 2)
              ]))
            : _createCommentVNode("", true),
          (showPreview.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                _createElementVNode("div", { class: "emb-card" }, [
                  _createElementVNode("div", {
                    class: "tbIcon embtoolbox_in",
                    onClick: svgZoomIn
                  }),
                  _createElementVNode("div", {
                    class: "tbIcon embtoolbox_out",
                    onClick: svgZoomOut
                  })
                ])
              ]))
            : _createCommentVNode("", true),
          (showPreview.value)
            ? (_openBlock(), _createBlock(MapPreview, {
                key: 2,
                ref_key: "mapPreview",
                ref: mapPreview,
                svgUrl: svgUrl.value,
                NECornerLatitude: NECornerLatitude.value,
                NECornerLongitude: NECornerLongitude.value,
                CenterpointLatitude: CenterpointLatitude.value,
                CenterpointLongitude: CenterpointLongitude.value,
                SWCornerLatitude: SWCornerLatitude.value,
                SWCornerLongitude: SWCornerLongitude.value,
                mapZoom: +zoom.value,
                onChangeZoomLevel: changeZoomLevel
              }, null, 8, ["svgUrl", "NECornerLatitude", "NECornerLongitude", "CenterpointLatitude", "CenterpointLongitude", "SWCornerLatitude", "SWCornerLongitude", "mapZoom"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_46, [
      _createElementVNode("div", _hoisted_47, [
        _createElementVNode("div", _hoisted_48, [
          _createElementVNode("div", _hoisted_49, [
            _createElementVNode("h2", _hoisted_50, _toDisplayString(messages.value.geoPositioningTitle), 1),
            _createElementVNode("h4", _hoisted_51, _toDisplayString(messages.value.geoPositioningSecondaryTitle), 1),
            _cache[14] || (_cache[14] = _createElementVNode("div", { class: "form-group" }, [
              _createElementVNode("input", {
                type: "text",
                class: "form-control",
                placeholder: "Search by landmark, address, ZIP code, etc.",
                onfocus: "this.placeholder=''",
                onblur: "this.placeholder='Search by landmark, address, ZIP code, etc.'"
              }),
              _createElementVNode("span", { class: "search-icon" })
            ], -1))
          ]),
          _createElementVNode("div", _hoisted_52, [
            _createElementVNode("h4", _hoisted_53, _toDisplayString(messages.value.geoPositioningH4Message), 1),
            _createElementVNode("p", _hoisted_54, _toDisplayString(messages.value.geoPositioningP1Message), 1),
            _createElementVNode("p", null, _toDisplayString(messages.value.geoPositioningP2Message), 1),
            _createElementVNode("div", _hoisted_55, [
              _createElementVNode("div", _hoisted_56, [
                _createElementVNode("h5", _hoisted_57, _toDisplayString(messages.value.neCorner), 1),
                _cache[15] || (_cache[15] = _createElementVNode("div", { class: "form-group" }, [
                  _createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    placeholder: "30.611895"
                  })
                ], -1)),
                _cache[16] || (_cache[16] = _createElementVNode("div", { class: "form-group" }, [
                  _createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    placeholder: "-97.850491"
                  })
                ], -1))
              ]),
              _createElementVNode("div", _hoisted_58, [
                _createElementVNode("h5", _hoisted_59, _toDisplayString(messages.value.cornerPoint), 1),
                _cache[17] || (_cache[17] = _createElementVNode("div", { class: "form-group" }, [
                  _createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    placeholder: "30.611895"
                  })
                ], -1)),
                _cache[18] || (_cache[18] = _createElementVNode("div", { class: "form-group" }, [
                  _createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    placeholder: "-97.850491"
                  })
                ], -1))
              ]),
              _createElementVNode("div", _hoisted_60, [
                _createElementVNode("h5", _hoisted_61, _toDisplayString(messages.value.swCorner), 1),
                _cache[19] || (_cache[19] = _createElementVNode("div", { class: "form-group" }, [
                  _createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    placeholder: "30.611895"
                  })
                ], -1)),
                _cache[20] || (_cache[20] = _createElementVNode("div", { class: "form-group" }, [
                  _createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    placeholder: "-97.850491"
                  })
                ], -1))
              ])
            ])
          ]),
          _cache[21] || (_cache[21] = _createStaticVNode("<div class=\"form-group\" style=\"display:flex;\" data-v-0f1daf89><button class=\"btn\" style=\"margin-left:auto;\" data-v-0f1daf89> Copy coordinates (JSON) <span class=\"file-icon\" data-v-0f1daf89><img src=\"" + _imports_0 + "\" data-v-0f1daf89></span></button><button class=\"clear-all-btn\" data-v-0f1daf89>Clear All</button></div>", 1))
        ]),
        _cache[22] || (_cache[22] = _createStaticVNode("<div class=\"overlaytool_right\" data-v-0f1daf89><div class=\"embtoolbox\" data-v-0f1daf89><div class=\"emb-card\" data-v-0f1daf89><div class=\"tbIcon embtoolbox_in\" data-v-0f1daf89></div><div class=\"tbIcon embtoolbox_out\" data-v-0f1daf89></div></div></div></div>", 1))
      ])
    ])
  ]))
}
}

})